export default (response: Response) => response.json()
